export enum UserRoles {
    GUEST = 'guest',
    USER = 'user',
    ADMIN = 'admin',
    SUBSCRIBER = 'subscriber',
    PROFESSOR = 'professor',
    BUYER = 'buyer',
}

export type AvatarResponse = {
    id: string;
    title: string;
    size: number;
};

export type UserForgotPassword = {
    email: string;
    captchaToken: string;
};

export type UserResetPassword = {
    password: string;
    confirmPassword: string;
    token: string;
};

export type UserData = {
    id: number;
    email: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    role: string;
    token: string;
};

export type UserInfo = {
    id: string;
    username: string;
    displayName: string;
    avatarUrl: string;
    darkMode: boolean;
    showAds: boolean;
    energy: number;
};

export type UserDetails = {
    id: string;
    username: string;
    displayName: string;
    avatarUrl: string;
    roles: string[];
};

export type UserSocketDetails = {
    username: string;
    socket_id: string;
    user_id: string;
    room_id: string;
};

export type UserRoleDetails = {
    id: string;
    username: string;
    displayName: string;
    avatarUrl: string;
    roles: string[];
};

export type UserJWTDetails = {
    id: string;
    username: string;
    roles: string[];
};
